export const hash = '519ed92c-a56b-11ec-920b-16b38c2c4059';

// export const gateKey = 'ek_test_BceiJ0MOrV39TWiFyRXIttpdUmhGn0';
export const gateKey = 'ek_live_wfnu8aW29jmHk7opMR6MNUoolPz38s';
export const recaptchaKey = '6LdKIrgZAAAAAFCgNLBhpQNO_a29D30zbLGQx9mb';
export const apiUrl = `https://api-global.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://global-socket.encontrodigital.com.br/';
// export const apiSocket = 'http://localhost:8001';

//export const apiUrl = `http://localhost:8000/${hash}`;

export const urlWebsite = 'https://encontro-previdencia-complementar.encontrodigital.com.br';
export const supportNumber = `5551981476007`;
export const home = 'Home';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = '12º ENCONTRO DE PREVIDÊNCIA COMPLEMENTAR-REGIÃO SUL ';
export const logo = '/assets/logo-2.png';
export const background = '/assets/Fundo.jpg';
export const authTitle = '12º ENCONTRO DE PREVIDÊNCIA COMPLEMENTAR-REGIÃO SUL ';

export const social = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  linkedin: '',
  youtube: '',
  twitter: '',
};

export const dadosOrganizacao = '';

export const defaultTheme = {
  defaultBackground: 'rgb(0, 62, 21)',
  defaultColor: '#fff',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: 'none',
    backgroundSticky: 'none',
    backgroundMobile: 'rgb(0, 62, 21)',
    color: '#f5bf0a',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
